import React, {useState} from "react";
import {
    Button,
    Column,
    Columns,
    Control,
    Field,
    Input,
    Modal,
    Section,
    Select,
    Title,
} from "@allxsmith/bestax-bulma";
import axios from "axios";
import {ToastContainer,  toast} from "react-toastify";


export default function CreateNewContactModal({open, setOpen}){
    const defaultContact = {
        additional_contacts: [], // These are needed as create endpoint key scans for them array['key']
        part_contacts: [],
        workshop_contacts: [],
        workshop_instructions: [],
        rental_instructions: [],
        contact_type: "CC",
        display_name: "",
        labour_rate: 40,
        labour_rate_markup: 0,
        partial_contact: true,
        payment_term_days: 0,
        workshop_account_code: "02",
        deposit_account_code: "03",
        hire_account_code: "01",
        part_account_code: "05",
        movement_account_code: "08",
        company_name: "",
        company_phone_type: "Phone",
        company_phone: "",
        company_phone_country_code: "",
        company_phone_area_code: "",
        company_email: ""
    }
    const [contact ,setContact] = useState(defaultContact);

    const phoneTypeOptions = [
      {name: "Landline", value: "Phone"},
      {name: "Mobile", value: "Mobile"},
      {name: "Fax", value: "Fax"}
    ];

    const handleChange = e => {
        let newContact = {...contact};
        newContact[e.target.name] = e.target.value;
        setContact(newContact);
    };

    const validator = () => {
        let valid = true;
        valid = valid && !!contact.display_name;
        valid = valid && !!contact.company_name;
        valid = valid && !!contact.company_email;
        valid = valid && !!contact.company_phone_type;
        valid = valid && !!contact.company_phone;

        if(contact.company_phone_type === "Phone"){
            valid = valid && contact.company_phone_area_code;
        }
        if(contact.company_phone_type !== "Fax"){
            valid = valid && contact.company_phone_country_code;
        }

        return valid;
    }

    const onSave = () => {
        const conf = {
            method: "post",
            data: contact,
            url: "/api/contacts"
        };
        if(validator()) {
            axios(conf).then(res => {
                setOpen(false);
                setContact(defaultContact);
            }).catch(err => {
                toast.error("There was an error creating contact",  {position: "top-right"})
            })
        }
        else{
            toast.warning("Display Name, Company Name, Company Email and All Company Phone Details are required", {postition: "top-right"})
        }
    }

    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            active={open}
            onClose={() => setOpen(false)}
            closeOnBlur
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{background: "white"}}>
                    <Columns isMultiline>
                        <Column>
                            <Title>Create New Partial Contact</Title>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Field className="has-addons">
                              <Control>
                                <label className="label">Type</label>
                                <Button
                                  color={contact.contact_type === "CC" ? "primary" : ""}
                                  onClick={() => handleChange({target: {name: "contact_type", value: "CC"}})}
                                >
                                  Customer
                                </Button>
                                <Button
                                  color={contact.contact_type === "SP" ? "primary" : ""}
                                  onClick={() => handleChange({target: {name: "contact_type", value: "SP"}})}
                                >
                                  Supplier
                                </Button>
                              </Control>
                            </Field>
                        </Column>
                        <Column>
                            <label className="label">Display Name</label>
                            <Input
                                name={"display_name"}
                                value={contact.display_name}
                                onChange={handleChange}
                                type={"text"}
                            />
                        </Column>
                        <Column>
                            <label className="label">Company Name</label>
                            <Input
                                name={"company_name"}
                                value={contact.company_name}
                                onChange={handleChange}
                                type={"text"}
                            />
                        </Column>
                        <Column>
                            <label className="label">Company Email</label>
                            <Input
                                name={"company_email"}
                                value={contact.company_email}
                                onChange={handleChange}
                                type={"email"}
                            />
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <label className="label">Phone Type</label>
                            <Select
                                name={"company_phone_type"}
                                value={contact.company_phone_type}
                                onChange={handleChange}
                            >
                                {phoneTypeOptions.map((option) => (
                                  <option value={option.value}>{option.name}</option>
                                ))}
                            </Select>
                        </Column>
                        {contact.company_phone_type !== "Fax" &&
                            <Column>
                                <label className="label">Country Code</label>
                                <Input
                                    name={"company_phone_country_code"}
                                    value={contact.company_phone_country_code}
                                    onChange={handleChange}
                                    type={"text"}
                                />
                            </Column>
                        }
                        {contact.company_phone_type === "Phone" &&
                            <Column>
                                <label className="label">Area Code</label>
                                <Input
                                    name={"company_phone_area_code"}
                                    value={contact.company_phone_area_code}
                                    onChange={handleChange}
                                    type={"text"}
                                />
                            </Column>
                        }
                        <Column>
                            <label className="label">Phone Number</label>
                            <Input
                                name={"company_phone"}
                                value={contact.company_phone}
                                onChange={handleChange}
                                type={"text"}
                            />
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Button
                                color={"success"}
                                onClick={onSave}
                                isFullWidth
                            >
                                Create
                            </Button>
                        </Column>
                        <Column>
                            <Button
                                color={"info"}
                                onClick={() => setOpen(false)}
                                isFullWidth
                            >
                                Cancel
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );


}